import React from "react";
import "../assets/about.css";
import { Link } from "react-router-dom";
const About = () => {
  return (
    <>
      {/* PAGE HERO */}
      <section className="about-hero">
        <div className="container">
          <h1>About Sibora Global</h1>
          <p>
            Empowering businesses with reliable global services,
            innovative technology, and strategic consulting.
          </p>
        </div>
      </section>

      {/* COMPANY OVERVIEW */}
      <section className="about-section">
        <div className="container about-grid">

          <div className="about-text">
            <h2>Who We Are</h2>

            <p>
              Sibora Global is a modern international services firm focused on
              delivering scalable, reliable and future-ready business solutions
              across global markets.
            </p>

            <p>
              Our team combines expertise in finance, technology and digital
              transformation to help organizations expand, optimize operations
              and achieve sustainable growth.
            </p>

          </div>

          <div className="about-image">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
              alt="Team working"
            />
          </div>

        </div>
      </section>


      {/* MISSION VISION VALUES */}

      <section className="about-values">
        <div className="container values-grid">

          <div className="value-card">
            <h3>Our Mission</h3>
            <p>
              Deliver high-quality professional services that drive innovation,
              efficiency and global growth.
            </p>
          </div>

          <div className="value-card">
            <h3>Our Vision</h3>
            <p>
              Become a trusted global partner helping businesses expand
              internationally with confidence.
            </p>
          </div>

          <div className="value-card">
            <h3>Our Values</h3>
            <p>
              Integrity, collaboration, excellence and long-term client success
              guide everything we do.
            </p>
          </div>

        </div>
      </section>


      {/* CTA */}

      <section className="about-cta">
        <div className="container">
          <h2>Partner With Sibora Global</h2>
          <p>
            Let’s work together to build scalable, future-ready business
            solutions.
          </p>

          <Link to="/contact" className="primary-btn">
            Contact Our Team
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;